"use client"

import React from "react"

import { useState } from "react"
import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Textarea } from "@/components/ui/textarea"
import { ArrowRight } from "lucide-react"

interface DemoModalProps {
  children: React.ReactNode
}

export function DemoModal({ children }: DemoModalProps) {
  const [open, setOpen] = useState(false)
  const [formData, setFormData] = useState({
    nome: "",
    telefone: "",
    mensagem: "",
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    
    const whatsappNumber = "5511999999999" // Substitua pelo numero real
    const text = `Olá! Meu nome é ${formData.nome}.%0A%0ATelefone: ${formData.telefone}%0A%0AO que procuro: ${formData.mensagem}`
    
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${text}`
    window.open(whatsappUrl, "_blank")
    
    setOpen(false)
    setFormData({ nome: "", telefone: "", mensagem: "" })
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {children}
      </DialogTrigger>
      <DialogContent className="sm:max-w-md bg-card border-border">
        <DialogHeader>
          <DialogTitle className="text-foreground text-xl">Solicitar Demonstração</DialogTitle>
          <DialogDescription className="text-muted-foreground">
            Preencha os dados abaixo e entraremos em contato via WhatsApp.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4 mt-4">
          <div className="flex flex-col gap-2">
            <Label htmlFor="nome" className="text-foreground">Nome</Label>
            <Input
              id="nome"
              placeholder="Seu nome completo"
              value={formData.nome}
              onChange={(e) => setFormData({ ...formData, nome: e.target.value })}
              required
              className="bg-secondary border-border text-foreground placeholder:text-muted-foreground"
            />
          </div>
          <div className="flex flex-col gap-2">
            <Label htmlFor="telefone" className="text-foreground">Telefone / WhatsApp</Label>
            <Input
              id="telefone"
              placeholder="(11) 99999-9999"
              value={formData.telefone}
              onChange={(e) => setFormData({ ...formData, telefone: e.target.value })}
              required
              className="bg-secondary border-border text-foreground placeholder:text-muted-foreground"
            />
          </div>
          <div className="flex flex-col gap-2">
            <Label htmlFor="mensagem" className="text-foreground">O que você procura?</Label>
            <Textarea
              id="mensagem"
              placeholder="Descreva brevemente sua necessidade..."
              value={formData.mensagem}
              onChange={(e) => setFormData({ ...formData, mensagem: e.target.value })}
              required
              rows={3}
              className="bg-secondary border-border text-foreground placeholder:text-muted-foreground resize-none"
            />
          </div>
          <Button type="submit" className="w-full bg-primary text-primary-foreground hover:bg-primary/90 gap-2 mt-2">
            Enviar via WhatsApp
            <ArrowRight className="w-4 h-4" />
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  )
}
